import modifiersImage from '../../images/modifiers.png';
import { DashboardContainer } from '../inventory-management/inventory-dashboard.styles';

export function Modifiers() {
  return (
    <DashboardContainer>
      <img src={modifiersImage} height='100%' alt='modifiers' />
    </DashboardContainer>
  );
}
